import { clearSession } from "../../utils";
import {
  ADD_BULK_USERS_SUCCESS,
  ADD_USER_SUCCESS,
  APP_ERROR,
  CREATE_SINGLE_USER_FILE_SUCCESS,
  DELETE_USER_ERROR,
  DELETE_USER_SUCCESS,
  EDIT_USER_ERROR,
  EDIT_USER_IMAGE_SUCCESS,
  EDIT_USER_SUCCESS,
  FILE_UPLOAD_COMPLETED,
  FILE_UPLOAD_STARTED,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWWORD_FAILED,
  GET_ALL_USER_CSV_FAILED,
  GET_ALL_USER_CSV_SUCCESS,
  GET_ALL_USER_FAILED,
  GET_ALL_USER_SUCCESS,
  GET_LOGIN_COUNT_HISTORY_ERROR,
  GET_LOGIN_COUNT_HISTORY_SUCCESS,
  GET_LOGIN_HOSTORY_PAST_30_DAYS,
  GET_LOGIN_HOSTORY_PAST_30_DAYS_FAILED,
  GET_LOGIN_ROLE_COUNT,
  GET_LOGIN_ROLE_COUNT_FAILED,
  GET_PASSED_STUDENTS_CSV_FAILED,
  GET_PASSED_STUDENTS_CSV_SUCCESS,
  GET_USERROLES_FAILED,
  GET_USERROLES_SUCCESS,
  GET_USER_ERROR,
  GET_USER_ID_ERROR,
  GET_USER_ID_SUCCESS,
  GET_USER_SUCCESS,
  LOG_OUT_USER,
  REQUEST_COMPLETED,
  REQUEST_STARTED,
  RESET_FORGET_PASSWORD,
  RESET_LOGIN_HOSTORY_PAST_30_DAYS,
  RESET_LOGIN_ROLE_COUNT,
  RESET_PASSWORD_SUCCESS,
  RESET_UPDATE_PASSWORD_SUCCESS,
  RESET_USER_BY_ID_SUCCESS,
  RESET_USER_DETAILS,
  RESET_VALIDATE_PASSWORD,
  SEND_EMAIL_TO_USER_ERROR,
  SEND_EMAIL_TO_USER_SUCCESS,
  SET_USER_DETAILS,
  UPDATE_PASSWORD_SUCCESS,
  USER_ACTION_ERROR,
  USER_ACTION_SUCCESS,
  VALIDATE_PASSWORD_SUCCESS,
} from "../constants";
import { deleteReq, get, post, postImage, postWithNoToken, put } from "./axios";

export const setUserDetails = (userDetails) => async (dispatch) => {
  //
  dispatch({ type: SET_USER_DETAILS, payload: userDetails });
};

// export const logUserLogoutDetails = (userId) => {
//
//   return {
//     type: LOGOUT_DETAILS,
//     payload: {
//       userId,
//     },
//   };
// };

// export const logoutUser = () => async (dispatch) => {
//   clearSession();
//   dispatch({ type: LOG_OUT_USER });
// };
export const logoutUser = () => async (dispatch) => {
  clearSession();
  dispatch({ type: LOG_OUT_USER });
  // dispatch(logUserLogoutDetails(userId));
};
export const getAllUsersForDropDown = (role) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });

    const searchParams = new URLSearchParams();
    role.map((item) => searchParams.append("role", item));
    const result = await get(`/user/getAll?${searchParams}`);
    dispatch({
      type: GET_ALL_USER_SUCCESS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_USER_FAILED,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  } finally {
    // dispatch({ type: REQUEST_COMPLETED });
  }
};

//To display all users
export const displayAllUsers = (queryData) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const searchParams = new URLSearchParams(queryData);
    const result = await get(`/user/?${searchParams}`);

    dispatch({
      type: GET_USER_SUCCESS,
      payload: result,
    });
    dispatch({ type: REQUEST_COMPLETED });
  } catch (err) {
    if (err.response && err.response.status === 401) {
      dispatch(logoutUser());
    }
    dispatch({ type: REQUEST_COMPLETED });
    dispatch({
      type: GET_USER_ERROR,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};

//To add user
export const addUsers = (body) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await postWithNoToken(`/user`, body);
    dispatch({
      type: ADD_USER_SUCCESS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: APP_ERROR,
      payload: {
        type: "Error",
        message: err.response?.data?.message,
      },
    });
  } finally {
    dispatch({ type: REQUEST_COMPLETED });
  }
};

export const bulkUploadStudents = (body) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await post(`/bulkUpload`, body);
    dispatch({
      type: ADD_BULK_USERS_SUCCESS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: APP_ERROR,
      payload: {
        type: "Error",
        message: err.response?.data?.message,
      },
    });
  } finally {
    dispatch({ type: REQUEST_COMPLETED });
  }
};

export const addUserActions = (body) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await postWithNoToken(`/user/user-action`, body);
    dispatch({
      type: USER_ACTION_SUCCESS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: USER_ACTION_ERROR,
      payload: {
        type: "Error",
        message: err.response?.data?.message,
      },
    });
  } finally {
    dispatch({ type: REQUEST_COMPLETED });
  }
};

//To edit user
export const editUsers = (body, data) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await put(`/user`, body);
    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: result,
    });
    if (data) {
      dispatch(displayAllUsers(data));
    }
    // dispatch(getUserById(body.id));
  } catch (err) {
    dispatch({
      type: EDIT_USER_ERROR,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  } finally {
    dispatch({ type: REQUEST_COMPLETED });
  }
};

export const editUsersImage = (body) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await put(`/user`, body);
    console.log("result uaer iage: ", result);
    dispatch({
      type: EDIT_USER_IMAGE_SUCCESS,
      payload: result?.data,
    });
    // if (data) {
    //   dispatch(displayAllUsers(data));
    // }
    // dispatch(getUserById(body.id));
  } catch (err) {
    dispatch({
      type: EDIT_USER_ERROR,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  } finally {
    dispatch({ type: REQUEST_COMPLETED });
  }
};

//To delete users
export const deleteUser = (id) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await deleteReq(`/user/${id}`);
    dispatch({
      type: DELETE_USER_SUCCESS,
      payload: result?.data,
    });
    dispatch({ type: REQUEST_COMPLETED });
  } catch (err) {
    dispatch({ type: REQUEST_COMPLETED });
    dispatch({
      type: DELETE_USER_ERROR,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};

//To get user by id
export const displayUserById = (id) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await get(`/user/details/${id}`);
    dispatch({
      type: GET_USER_ID_SUCCESS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: GET_USER_ID_ERROR,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};

export const resetdisplayUserById = () => async (dispatch) => {
  dispatch({ type: RESET_USER_BY_ID_SUCCESS });
};

export const resetUsers = () => async (dispatch) => {
  dispatch({ type: RESET_USER_DETAILS });
};

//To display all user roles
export const displayAllUserRoles = () => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await get(`/user/roles`);
    dispatch({
      type: GET_USERROLES_SUCCESS,
      payload: result,
    });
    dispatch({ type: REQUEST_COMPLETED });
  } catch (err) {
    dispatch({ type: REQUEST_COMPLETED });
    dispatch({
      type: GET_USERROLES_FAILED,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};

export const uploadImageTest = () => async (dispatch) => {
  dispatch({ type: CREATE_SINGLE_USER_FILE_SUCCESS });
};

export const uploadUserImage = (file, type) => async (dispatch) => {
  try {
    dispatch({ type: FILE_UPLOAD_STARTED });
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    const result = await postImage(`/user/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (result) {
      //
      dispatch({
        type: CREATE_SINGLE_USER_FILE_SUCCESS,
        payload: result,
      });
    }
    dispatch({ type: FILE_UPLOAD_COMPLETED });
  } catch (error) {
    dispatch({ type: FILE_UPLOAD_COMPLETED });
  } finally {
    dispatch({ type: FILE_UPLOAD_COMPLETED });
  }
};

export const uploadUserPhoto = async (file, type) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    const result = await postImage(`/user/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (result) {
      return { success: true, data: { ...result } };
    }
  } catch (error) {
    return { success: false };
  } finally {
  }
};

export const uploadProfilePicture = (userId, file) => async (dispatch) => {
  try {
    dispatch({ type: FILE_UPLOAD_STARTED });
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", "profile");

    const result = await postImage(
      `/user/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      dispatch
    );
    if (result && result.url) {
      dispatch(editUsersImage({ id: userId, profilePicture: result }));
    }
    dispatch({ type: FILE_UPLOAD_COMPLETED });
  } catch (error) {
    dispatch({ type: FILE_UPLOAD_COMPLETED });
  } finally {
    dispatch({ type: FILE_UPLOAD_COMPLETED });
  }
};

//reset password
export const resetPassword = (body) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });

    const result = await post(`/user/reset-password`, body);
    dispatch({
      type: RESET_PASSWORD_SUCCESS,
      payload: result,
    });
    dispatch({
      type: APP_ERROR,
      payload: {
        type: "Success",
        message: result?.message,
        color: "green",
      },
    });
    dispatch({ type: REQUEST_COMPLETED });
  } catch (err) {
    dispatch({
      type: APP_ERROR,
      payload: {
        type: "Error",
        message: err.response?.data?.message,
      },
    });
  } finally {
    dispatch({ type: REQUEST_COMPLETED });
  }
};

//forget password
export const forgetPasswordApi = (body) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });

    const result = await post(`/user/forget-password`, body);
    if (result.success) {
      dispatch({
        type: FORGET_PASSWORD_SUCCESS,
        payload: result,
      });
    } else {
      dispatch({
        type: FORGET_PASSWWORD_FAILED,
        payload: result,
      });
    }
  } catch (err) {
    dispatch({
      type: FORGET_PASSWWORD_FAILED,
      payload: {
        success: false,
        message: "Something went wrong, Please try again later",
      },
    });
  } finally {
    dispatch({ type: REQUEST_COMPLETED });
  }
};

export const resetForgetPassword = (body) => async (dispatch) => {
  dispatch({
    type: RESET_FORGET_PASSWORD,
  });
};

export const validatePasswordKey = (key) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await get(`/user/verifyKey/${key}`);
    dispatch({
      type: VALIDATE_PASSWORD_SUCCESS,
      payload: result,
    });
    dispatch({ type: REQUEST_COMPLETED });
  } catch (err) {
    dispatch({ type: REQUEST_COMPLETED });
  }
};

export const resetValidatePassword = (body) => async (dispatch) => {
  dispatch({
    type: RESET_VALIDATE_PASSWORD,
  });
};

export const resetUpdatePassword = (body) => async (dispatch) => {
  dispatch({
    type: RESET_UPDATE_PASSWORD_SUCCESS,
  });
};

export const updatePasswordAPI = (body) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });

    const result = await post(`/user/update-forget-password`, body);
    if (result.success) {
      dispatch({
        type: UPDATE_PASSWORD_SUCCESS,
        payload: result,
      });
    } else {
      dispatch({
        type: UPDATE_PASSWORD_SUCCESS,
        payload: result,
      });
    }
  } catch (err) {
    dispatch({
      type: FORGET_PASSWWORD_FAILED,
      payload: {
        success: false,
        message: "Something went wrong, Please try again later",
      },
    });
  } finally {
    dispatch({ type: REQUEST_COMPLETED });
  }
};

export const displayAllUserCsv = () => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await get(`/user/getAllUsers`);
    dispatch({
      type: GET_ALL_USER_CSV_SUCCESS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_USER_CSV_FAILED,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};

export const getDailyLoginCountsForPast30Days = () => async (dispatch) => {
  try {
    // dispatch({ type: REQUEST_STARTED });
    const result = await get(`/user/loginHistory`);
    dispatch({
      type: GET_LOGIN_HOSTORY_PAST_30_DAYS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: GET_LOGIN_HOSTORY_PAST_30_DAYS_FAILED,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};
export const resetDailyLoginCount = () => async (dispatch) => {
  dispatch({ type: RESET_LOGIN_HOSTORY_PAST_30_DAYS });
};
export const getDailyRoleCountsForPast30Days = () => async (dispatch) => {
  try {
    // dispatch({ type: REQUEST_STARTED });
    const result = await get(`/user/roleCount`);
    dispatch({
      type: GET_LOGIN_ROLE_COUNT,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: GET_LOGIN_ROLE_COUNT_FAILED,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};
export const resetDailyRoleCount = () => async (dispatch) => {
  dispatch({ type: RESET_LOGIN_ROLE_COUNT });
};
export const getUserCountForHomePage = () => async (dispatch) => {
  try {
    // dispatch({ type: REQUEST_STARTED });
    const result = await get(`/user/loginHistoryCount`);
    dispatch({
      type: GET_LOGIN_COUNT_HISTORY_SUCCESS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: GET_LOGIN_COUNT_HISTORY_ERROR,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};

export const sendEmailToUsers = (data) => async (dispatch) => {
  try {
    const result = await post(`/user/sendEmail`, data);
    dispatch({
      type: SEND_EMAIL_TO_USER_SUCCESS,
      payload: result,
    });
    console.log("result in send Email To Users Result: ", result);
  } catch (err) {
    console.log("err: ", err);
    dispatch({
      type: SEND_EMAIL_TO_USER_ERROR,
      payload:
        err?.response?.data?.message ||
        "Unable to send email at the moment. Please Try Again.",
    });
    console.log(err);
  }
};

export const displayPassedStudentsCsv = () => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const result = await get(`/user/get-pass-students`);
    dispatch({
      type: GET_PASSED_STUDENTS_CSV_SUCCESS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: GET_PASSED_STUDENTS_CSV_FAILED,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};

export const displayAllUserCsvTwo = (queryData) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_STARTED });
    const searchParams = new URLSearchParams(queryData);
    const result = await get(`/user/?${searchParams}`);
    dispatch({
      type: GET_ALL_USER_CSV_SUCCESS,
      payload: result,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_USER_CSV_FAILED,
      payload:
        err?.response?.data?.message ||
        "Unable to fetch records at the moment. Please Try Again.",
    });
  }
};